import { Controller } from "stimulus";
import $ from "jquery";
import {removeHtmlElementClass} from "../utils/utils";

export default class extends Controller {
    // Mostra l'overlay di attesa. Se l'elemento contiene campi con data-loading-overlay-original (il valore
    // salvato), l'overlay compare solo quando almeno uno di questi è stato modificato: serve ai form in cui solo
    // alcune modifiche avviano operazioni lunghe (es. le chiamate a Promelit dell'espositore).
    // Se l'elemento sta dentro una modale (es. la conferma della cancellazione), la modale si chiude e resta
    // visibile solo l'overlay.
    // Con data-loading-overlay-id si sceglie quale overlay mostrare, se nella pagina ce n'è più di uno
    handleSubmitForm() {
        const watchedFields = this.element.querySelectorAll("[data-loading-overlay-original]");
        const someWatchedFieldChanged = Array.from(watchedFields).some(
            field => field.value !== field.dataset.loadingOverlayOriginal
        );
        if (watchedFields.length > 0 && !someWatchedFieldChanged)
            return;

        const modal = this.element.closest(".modal");
        if (modal)
            $(modal).modal("hide");

        removeHtmlElementClass(document, this.element.dataset.loadingOverlayId || "loading_overlay", "d-none");
    }
}
